import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ExportButton from "@components/export-button";
import { getPowerBIAccessToken } from "@queries/powerbi-reports";
import { getAuthToken } from "@utils/services/auth";
import axios from "axios";
import download from "downloadjs";
import { PDFDocument } from "pdf-lib";
import React, { useEffect, useRef, useState } from "react";
import profileTabs from "./profile-tabs";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ExportProfile = function(param) {
    var printReportConfig = param.printReportConfig;
    var ref = useState(false), isProcessing = ref[0], setIsProcessing = ref[1];
    var ref1 = useState(false), isDone = ref1[0], setIsDone = ref1[1];
    var ref2 = useState(0), progress = ref2[0], setProgress = ref2[1];
    var timerRef = useRef(null);
    var ref3 = useState(null), token = ref3[0], setToken = ref3[1];
    var ref4 = useState(null), exportIds = ref4[0], setExportIds = ref4[1];
    useEffect(function() {
        getAuthToken().then(function(token) {
            getPowerBIAccessToken(token).then(function(param) {
                var data = param.data;
                setToken(data);
            });
        });
    }, []);
    useEffect(function() {
        var _a;
        var type = (printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}).type;
        var ref = (_a = profileTabs[type]) !== null && _a !== void 0 ? _a : {}, workspaceId = ref.workspaceId, reportId = ref.reportId;
        if (isProcessing && exportIds) {
            timerRef.current = setInterval(function() {
                return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                    var exportStatusDetails, hasError, allSuccess, sumProgress, status;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return axios.all(exportIds.map(function(exportId) {
                                    return axios.get("".concat(process.env.NEXT_PUBLIC_POWER_BI_REPORT_API, "/").concat(workspaceId, "/reports/").concat(reportId, "/exports/").concat(exportId), {
                                        headers: {
                                            "Access-Control-Allow-Origin": "*",
                                            Authorization: "Bearer ".concat(token),
                                            "Content-type": "application/json"
                                        }
                                    });
                                }));
                            case 2:
                                exportStatusDetails = _ctx.sent;
                                hasError = exportStatusDetails.some(function(param) {
                                    var status = param.data.status;
                                    return status === "Failed";
                                });
                                allSuccess = exportStatusDetails.every(function(param) {
                                    var status = param.data.status;
                                    return status === "Succeeded";
                                });
                                sumProgress = exportStatusDetails.reduce(function(accumulator, param) {
                                    var percentComplete = param.data.percentComplete;
                                    return accumulator + percentComplete;
                                }, 0);
                                status = "Started";
                                if (hasError) {
                                    status = "Failed";
                                }
                                if (allSuccess) {
                                    status = "Succeeded";
                                }
                                setProgress(sumProgress / exportStatusDetails.length);
                                if (status === "Succeeded") {
                                    setIsDone(true);
                                    clearInterval(timerRef.current);
                                }
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            }, 5000);
        }
    }, [
        exportIds,
        isProcessing,
        printReportConfig,
        token
    ]);
    useEffect(function() {
        var _a;
        var ref = printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}, fileName = ref.fileName, type = ref.type;
        var ref1 = (_a = profileTabs[type]) !== null && _a !== void 0 ? _a : {}, workspaceId = ref1.workspaceId, reportId = ref1.reportId;
        if (isDone && exportIds) {
            var getPDF = function() {
                return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                    var pdfDoc, exportFileDetails, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, pdfPage, copiedPage, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, page, document;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return PDFDocument.create();
                            case 3:
                                pdfDoc = _ctx.sent;
                                _ctx.next = 6;
                                return axios.all(exportIds.map(function(exportId) {
                                    return axios.get("".concat(process.env.NEXT_PUBLIC_POWER_BI_REPORT_API, "/").concat(workspaceId, "/reports/").concat(reportId, "/exports/").concat(exportId, "/file"), {
                                        headers: {
                                            "Access-Control-Allow-Origin": "*",
                                            Authorization: "Bearer ".concat(token),
                                            "Content-type": "application/json"
                                        },
                                        responseType: "arraybuffer"
                                    });
                                }));
                            case 6:
                                exportFileDetails = _ctx.sent;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _ctx.prev = 8;
                                _iterator = exportFileDetails[Symbol.iterator]();
                            case 10:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _ctx.next = 38;
                                    break;
                                }
                                data = _step.value.data;
                                _ctx.next = 14;
                                return PDFDocument.load(data);
                            case 14:
                                pdfPage = _ctx.sent;
                                _ctx.next = 17;
                                return pdfDoc.copyPages(pdfPage, pdfPage.getPageIndices());
                            case 17:
                                copiedPage = _ctx.sent;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _ctx.prev = 19;
                                for(_iterator1 = copiedPage[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    page = _step1.value;
                                    pdfDoc.addPage(page);
                                }
                                _ctx.next = 27;
                                break;
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](19);
                                _didIteratorError1 = true;
                                _iteratorError1 = _ctx.t0;
                            case 27:
                                _ctx.prev = 27;
                                _ctx.prev = 28;
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            case 30:
                                _ctx.prev = 30;
                                if (!_didIteratorError1) {
                                    _ctx.next = 33;
                                    break;
                                }
                                throw _iteratorError1;
                            case 33:
                                return _ctx.finish(30);
                            case 34:
                                return _ctx.finish(27);
                            case 35:
                                _iteratorNormalCompletion = true;
                                _ctx.next = 10;
                                break;
                            case 38:
                                _ctx.next = 44;
                                break;
                            case 40:
                                _ctx.prev = 40;
                                _ctx.t1 = _ctx["catch"](8);
                                _didIteratorError = true;
                                _iteratorError = _ctx.t1;
                            case 44:
                                _ctx.prev = 44;
                                _ctx.prev = 45;
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            case 47:
                                _ctx.prev = 47;
                                if (!_didIteratorError) {
                                    _ctx.next = 50;
                                    break;
                                }
                                throw _iteratorError;
                            case 50:
                                return _ctx.finish(47);
                            case 51:
                                return _ctx.finish(44);
                            case 52:
                                _ctx.next = 54;
                                return pdfDoc.save();
                            case 54:
                                document = _ctx.sent;
                                download(document, fileName, "application/pdf");
                                setIsDone(false);
                                setIsProcessing(false);
                                setExportIds(null);
                                _ctx.next = 64;
                                break;
                            case 61:
                                _ctx.prev = 61;
                                _ctx.t2 = _ctx["catch"](0);
                                throw _ctx.t2;
                            case 64:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            61
                        ],
                        [
                            8,
                            40,
                            44,
                            52
                        ],
                        [
                            19,
                            23,
                            27,
                            35
                        ],
                        [
                            28,
                            ,
                            30,
                            34
                        ],
                        [
                            45,
                            ,
                            47,
                            51
                        ]
                    ]);
                }));
            };
            getPDF();
        }
    }, [
        exportIds,
        isDone,
        printReportConfig,
        token
    ]);
    var exportReport = function() {
        return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            var _a, ref, profileName, dimension, type, ref1, workspaceId, reportId, exportDetails;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref = printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}, profileName = ref.profileName, dimension = ref.dimension, type = ref.type;
                        ref1 = (_a = profileTabs[type]) !== null && _a !== void 0 ? _a : {}, workspaceId = ref1.workspaceId, reportId = ref1.reportId;
                        setIsProcessing(true);
                        _ctx.next = 6;
                        return axios.all(profileTabs[type][dimension].map(function(param) {
                            var filter = param.filter, pages = param.pages;
                            return axios.post("".concat(process.env.NEXT_PUBLIC_POWER_BI_REPORT_API, "/").concat(workspaceId, "/reports/").concat(reportId, "/ExportTo"), {
                                format: "pdf",
                                powerBIReportConfiguration: {
                                    reportLevelFilters: [
                                        {
                                            filter: "".concat(filter, " '").concat(profileName, "'")
                                        }
                                    ],
                                    pages: pages
                                }
                            }, {
                                headers: {
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer ".concat(token),
                                    "Content-type": "application/json"
                                }
                            });
                        }));
                    case 6:
                        exportDetails = _ctx.sent;
                        setExportIds(exportDetails.map(function(param) {
                            var id = param.data.id;
                            return id;
                        }));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: printReportConfig.showExportButton && /*#__PURE__*/ _jsx(ExportButton, {
            exportReport: exportReport,
            isProcessing: isProcessing,
            progress: progress,
            token: token
        })
    });
};
export default ExportProfile;
